export enum NAVIGATION_ADMIN {
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=126378028
     */
    ADD_NAVIGATION_ITEM = 'NAVIGATION_ADMIN.ADD_NAVIGATION_ITEM',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=130004178
     */
    EDIT_NAVIGATION_ITEM = 'NAVIGATION_ADMIN.EDIT_NAVIGATION_ITEM',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=126385356
     */
    SECTION = 'NAVIGATION_ADMIN.SECTION',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=126385809
     */
    SECTION_DESCRIPTION = 'NAVIGATION_ADMIN.SECTION_DESCRIPTION',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=74500146
     */
    PICK_CONTENT_DESCRIPTION = 'ADMIN.MOBILE.NAVIGATION.PICK_CONTENT_DESCRIPTION',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=
     */
    PICK_CONTENT_LIST_DESCRIPTION = 'NAVIGATION_ADMIN.PICK_CONTENT_LIST_DESCRIPTION',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=74500251
     */
    PICK_COMMUNITY_DESCRIPTION = 'ADMIN.MOBILE.NAVIGATION.PICK_COMMUNITY_DESCRIPTION',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=182942104
     */
    PICK_ARTICLE_DESCRIPTION = 'ADMIN.MOBILE.NAVIGATION.PICK_ARTICLE_DESCRIPTION',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=241548064
     */
    PICK_DIRECTORY_DESCRIPTION = 'NAVIGATION_ADMIN.PICK_DIRECTORY_DESCRIPTION',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=241470914
     */
    PICK_USER_DIRECTORY_DESCRIPTION = 'NAVIGATION_ADMIN.PICK_USER_DIRECTORY_DESCRIPTION',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=79130114
     */
    EXTERNAL_LINK = 'ADMIN.MOBILE.NAVIGATION.EXTERNAL_LINK.DIALOG_TITLE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=74500646
     */
    PICK_EXTERNAL_CONTENT_DESCRIPTION = 'ADMIN.MOBILE.NAVIGATION.PICK_EXTERNAL_CONTENT_DESCRIPTION',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=128244513
     */
    SECTION_TITLE = 'NAVIGATION_ADMIN.SECTION_TITLE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=128246033
     */
    EXTERNAL_LINK_TITLE = 'NAVIGATION_ADMIN.EXTERNAL_LINK_TITLE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=128246002
     */
    EXTERNAL_LINK_DESCRIPTION = 'NAVIGATION_ADMIN.EXTERNAL_LINK_DESCRIPTION',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=128267205
     */
    CONTENT_DESCRIPTION = 'NAVIGATION_ADMIN.CONTENT_DESCRIPTION',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=128266048
     */
    COMMUNITY_DESCRIPTION = 'NAVIGATION_ADMIN.COMMUNITY_DESCRIPTION',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=128879947
     */
    ITEM_VISIBILITY = 'NAVIGATION_ADMIN.ITEM_VISIBILITY',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=146432125
     */
    MOVE_DISABLED_NO_SECTION = 'NAVIGATION_ADMIN.MOVE_DISABLED_NO_SECTION',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=146436106
     */
    MOVE_DISABLED_ONLY_ELEMENT = 'NAVIGATION_ADMIN.MOVE_DISABLED_ONLY_ELEMENT',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=216239939
     */
    ITEM_WILL_NOT_APPEAR_IN_NAVIGATION = 'NAVIGATION_ADMIN.ITEM_WILL_NOT_APPEAR_IN_NAVIGATION',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=234439508
     */
    FILTER_SHOW_IN = 'NAVIGATION_ADMIN.FILTER_SHOW_IN',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=234439503
     */
    FILTER_AS = 'NAVIGATION_ADMIN.FILTER_AS',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=232028457
     */
    DISPLAY_ONLY_FOR_LANGUAGES_DESCRIPTION = 'NAVIGATION_ADMIN.DISPLAY_ONLY_FOR_LANGUAGES_DESCRIPTION',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=235789975
     */
    EMPTY_LIST_TITLE = 'NAVIGATION_ADMIN.EMPTY_LIST_TITLE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=235790032
     */
    EMPTY_LIST_DESCRIPTION = 'NAVIGATION_ADMIN.EMPTY_LIST_DESCRIPTION',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=240332620
     */
    CUSTOM_CODE_ITEM_CLASSES_TITLE = 'NAVIGATION_ADMIN.CUSTOM_CODE_ITEM_CLASSES_TITLE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=10481819
     */
    CUSTOM_CODE_ITEM_CLASSES_HELPER = 'ADMIN.MAIN_NAV.STYLE_CLASSES_HELP',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=240332709
     */
    CUSTOM_CODE_ITEM_IDENTIFIER_TITLE = 'NAVIGATION_ADMIN.CUSTOM_CODE_ITEM_IDENTIFIER_TITLE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=241722771
     */
    HIDE_TITLE_IN_MAIN_NAVIGATION = 'NAVIGATION_ADMIN.HIDE_TITLE_IN_MAIN_NAVIGATION',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=244338757
     */
    USE_AS_SUB_NAV_TITLE = 'NAVIGATION_ADMIN.USE_AS_SUB_NAV_TITLE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=244338621
     */
    HIDE_CHILDREN_IN_MAIN_NAV = 'NAVIGATION_ADMIN.HIDE_CHILDREN_IN_MAIN_NAV',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=244337222
     */
    HIDE_IN_MAIN_NAV = 'NAVIGATION_ADMIN.HIDE_IN_MAIN_NAV',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=246222296
     */
    HIDE_IN_MAIN_NAV_HELPER = 'NAVIGATION_ADMIN.HIDE_IN_MAIN_NAV_HELPER',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=244331305
     */
    USE_AS_SUB_NAV_DESCRIPTION = 'NAVIGATION_ADMIN.USE_AS_SUB_NAV_DESCRIPTION',
    /*
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=247800162
     */
    SHOW_ONLY_VISIBLE_ACTIVATED_WARNING = 'NAVIGATION_ADMIN.SHOW_ONLY_VISIBLE_ACTIVATED_WARNING',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=260134543
     */
    NAVIGATION_ITEM_TITLE = 'NAVIGATION_ADMIN.NAVIGATION_ITEM_TITLE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=261958313
     */
    NOT_ALLOWED_TO_ADD_CONTENT_TO_SECTION = 'NAVIGATION_ADMIN.NOT_ALLOWED_TO_ADD_CONTENT_TO_SECTION',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=291034243
     */
    ITEM_TITLE_HELPER_CONTENT = 'NAVIGATION_ADMIN.ITEM_TITLE_HELPER_CONTENT',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=291034266
     */
    ITEM_TITLE_HELPER_COMMUNITY = 'NAVIGATION_ADMIN.ITEM_TITLE_HELPER_COMMUNITY',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=291034269
     */
    ITEM_TITLE_HELPER_CUSTOM_LIST = 'NAVIGATION_ADMIN.ITEM_TITLE_HELPER_CUSTOM_LIST',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=291034275
     */
    ITEM_TITLE_HELPER_DIRECTORY = 'NAVIGATION_ADMIN.ITEM_TITLE_HELPER_DIRECTORY',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=291034870
     */
    ITEM_TITLE_HELPER_USER_DIRECTORY = 'NAVIGATION_ADMIN.ITEM_TITLE_HELPER_USER_DIRECTORY',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=291035708
     */
    ITEM_VISIBILITY_HELPER_CONTENT = 'NAVIGATION_ADMIN.ITEM_VISIBILITY_HELPER_CONTENT',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=291036212
     */
    ITEM_VISIBILITY_HELPER_COMMUNITY = 'NAVIGATION_ADMIN.ITEM_VISIBILITY_HELPER_COMMUNITY',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=291036730
     */
    ITEM_VISIBILITY_HELPER_CUSTOM_LIST = 'NAVIGATION_ADMIN.ITEM_VISIBILITY_HELPER_CUSTOM_LIST',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=291037203
     */
    ITEM_VISIBILITY_HELPER_DIRECTORY = 'NAVIGATION_ADMIN.ITEM_VISIBILITY_HELPER_DIRECTORY',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=291037210
     */
    ITEM_VISIBILITY_HELPER_USER_DIRECTORY = 'NAVIGATION_ADMIN.ITEM_VISIBILITY_HELPER_USER_DIRECTORY',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=290419931
     */
    RESTRICT_ITEM_VISIBILITY = 'NAVIGATION_ADMIN.RESTRICT_ITEM_VISIBILITY',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=292891462
     */
    NAVIGATION_ITEM_VISIBILITY_IS_PUBLIC = 'NAVIGATION_ADMIN.NAVIGATION_ITEM_VISIBILITY_IS_PUBLIC',
    /*
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=424792720
     */
    PERSONAL_FEED = 'NAVIGATION_ADMIN.PERSONAL_FEED',
    /*
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=424787521
     */
    PERSONAL_FEED_DESCRIPTION = 'NAVIGATION_ADMIN.PERSONAL_FEED_DESCRIPTION',
    /*
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=424790290
     */
    JOURNEY = 'NAVIGATION_ADMIN.JOURNEY',
    /*
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=424790305
     */
    JOURNEY_DESCRIPTION = 'NAVIGATION_ADMIN.JOURNEY_DESCRIPTION',
    /*
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=424790755
     */
    VIDEO_GALLERY_DESCRIPTION = 'NAVIGATION_ADMIN.VIDEO_GALLERY_DESCRIPTION',
}
